import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter, className }) {
    return (
        <span class="filter-icon--remove" onClick={() => filter.remove()}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM3.96967 5.03033L6.93934 8L3.96967 10.9697L5.03033 12.0303L8 9.06066L10.9697 12.0303L12.0303 10.9697L9.06066 8L12.0303 5.03033L10.9697 3.96967L8 6.93934L5.03033 3.96967L3.96967 5.03033Z"></path>
            </svg>
            <span class="visually-hidden">Remove filter</span>
        </span>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="ns-d-flex ns-flex-wrap ns-align-items-center ns-selected-filters">
                <div class="ns-d-flex ns-flex-wrap ns-align-items-center">
                    {filters.map(filter => (
                        <div class="ns-selected-filter" key={`${filter.name}: ${filter.value}`}>
                            <span>{filter.name}: {filter.value}</span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <span
                    class="ns-anchor ns-remove-all"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    Remove all filters
                </span>
            </div>
        )
    )
}
